import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLandmark,
  faPhone,
  faEnvelope,
  faClock,
} from "@fortawesome/free-solid-svg-icons";

import HeaderComponent from "../components/common/HeaderComponent";
import FooterComponent from "../components/common/FooterComponent";
import OBAPageIntroComponent from "../components/common/OBAPageIntroComponent";
import SocialMediaComponent from "../components/common/SocialMediaComponent";

import logo from "../assests/oba_logo_nbg.png";

export default function ContactPage() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div
      className="d-flex flex-column min-vh-100 overflow-x-hidden"
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <HeaderComponent user={null} />
      {/* <NavigationPanelComponent /> */}

      <main className="flex-grow-1 py-5">
        <div className="container px-3">
          {/* Hero Section */}
          <OBAPageIntroComponent
            image={logo}
            title="Get in touch with us"
            description=" If you have any questions or would like to reach out, we are
                    always happy to assist. Connect with the Vidyaloka College
                    Old Boys’ Association, and we will get back to you promptly."
          />

          <div className="row g-4">
            {/* Contact Information */}
            <div className="col-lg-4" data-aos="fade-right">
              <div
                className="rounded-3 p-4 h-100"
                style={{
                  border: "1px solid #e9ecef",
                  backgroundColor: "#fff",
                }}
              >
                <h4 className="fw-bold mb-4">Contact Information</h4>

                <div className="mb-4">
                  <div className="d-flex align-items-start">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                      style={{
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faLandmark}
                        className="text-white"
                      />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-2">Address</h6>
                      <p className="text-muted mb-0">
                        Old Boys' Association
                        <br />
                        Vidyaloka College, Galle, Sri Lanka
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="d-flex align-items-start">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                      style={{
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <FontAwesomeIcon icon={faPhone} className="text-white" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-2">Phone</h6>
                      <p className="text-muted mb-0">
                        <a
                          href="tel:+94722241298"
                          className="text-decoration-none text-muted"
                        >
                          +94 72 224 1298
                        </a>
                        <br />
                        <a
                          href="tel:+94912241298"
                          className="text-decoration-none text-muted"
                        >
                          +94 91 224 1298
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="d-flex align-items-start">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                      style={{
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faEnvelope}
                        className="text-white"
                      />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-2">Email</h6>
                      <p className="text-muted mb-0">
                        <a
                          href="mailto:vidyalokaobagalle@gmail.com"
                          className="text-decoration-none text-muted"
                        >
                          vidyalokaobagalle@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="mb-4">
                  <div className="d-flex align-items-start">
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center me-3 bg-dark"
                      style={{
                        width: "35px",
                        height: "35px",
                      }}
                    >
                      <FontAwesomeIcon icon={faClock} className="text-white" />
                    </div>
                    <div>
                      <h6 className="fw-bold mb-2">Office Hours</h6>
                      <p className="text-muted mb-1">School Days</p>
                      <p className="text-muted mb-0">7:30 AM - 1:30 PM</p>
                    </div>
                  </div>
                </div>

                {/* Social Media Component */}
                <SocialMediaComponent title="Connect with us" />
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-8" data-aos="fade-left">
              <div
                className="rounded-3 p-4"
                style={{
                  border: "1px solid #e9ecef",
                  backgroundColor: "#fff",
                }}
              >
                <h4 className="fw-bold mb-4">Send us a message</h4>
                <form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="firstName" className="form-label">
                        First Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="lastName" className="form-label">
                        Last Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="email" className="form-label">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="phone" className="form-label">
                        Phone Number
                      </label>
                      <input type="tel" className="form-control" id="phone" />
                    </div>
                    <div className="col-12">
                      <label htmlFor="message" className="form-label">
                        Message
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        rows="5"
                        required
                      ></textarea>
                    </div>
                    <div className="col-12 d-flex justify-content-end">
                      <button type="submit" className="btn btn-dark">
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="mt-5" data-aos="fade-up">
            <div className="overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4313.848681096643!2d80.21412017533055!3d6.034815228648575!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae173bb71f1cbbb%3A0x24ef615fd68ca5f4!2zVmlkeWFsb2thIENvbGxlZ2UgLSBHYWxsZSB8IOC3gOC3kuC2r-C3iuKAjeC2uuC3j-C2veC3neC2miDgt4Dgt5Lgtq_gt4rigI3gtrrgt4_gtr3gtrog4Lac4LeP4La94LeK4La9IHwg4K614K6_4K6k4K-N4K6v4K6-4K6y4K-L4K6V4K6-IOCuleCusuCvjeCusuCvguCusOCuvyDgrpXgrr7grrLgrr8!5e1!3m2!1sen!2slk!4v1765828401490!5m2!1sen!2slk&z=18"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Vidyaloka College Location"
              ></iframe>
            </div>
          </div>
        </div>
      </main>

      <FooterComponent />
    </div>
  );
}
